"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = debounce;
const Functions_1 = require("../../Utility/Functions");
/**
 * Returns a function, that, as long as it continues to be invoked, will not be triggered. The function
 * will be called after it stops being called for N milliseconds. If `immediate` is passed, trigger
 * the function on the leading edge, instead of the trailing.
 */
function debounce(milliseconds, immediate = false) {
    return function debounceHandler(_target, _propertyKey, descriptor) {
        const map = new WeakMap();
        const originalMethod = descriptor.value;
        descriptor.value = function valueHandler(...params) {
            let debounced = map.get(this);
            if (debounced === undefined) {
                debounced = Functions_1.default.debounce(originalMethod, milliseconds, immediate).bind(this);
                map.set(this, debounced);
            }
            debounced(...params);
        };
        return descriptor;
    };
}
//# sourceMappingURL=Debounce.js.map